module.exports = __webpack_public_path__ + "img/download-thumb-1.7df1d24d.png";